import { useDispatch, useSelector } from 'react-redux'
import { SelectCustom } from '../../../common/selectCustom'
import { FILTER_BY } from '../../constant'
import { changeFilter, selectFilter } from '../store/slice'
export const Category = () => {
  const dispatch = useDispatch()
  const filterData = useSelector(selectFilter('filterBy'))

  const data = [
    {
      label: 'connectMap.entityMap.COMPANY',
      value: FILTER_BY.COMPANY,
      isI18n: true,
    },
    {
      label: 'connectMap.entityMap.PERSON',
      value: FILTER_BY.PERSON,
      isI18n: true,
    },
  ]
  const selectCategory = (data) => {
    dispatch(
      changeFilter({
        filterBy: data.value,
      }),
    )
  }

  return (
    <SelectCustom
      activeItem={
        data?.find((item) => item?.value === filterData) || FILTER_BY.COMPANY
      }
      data={data}
      style={{ maxWidth: 120, height: 28, backgroundColor: '#FFFFFF' }}
      isI18n
      chooseItem={selectCategory}
    />
  )
}
